import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL || 'https://takvim.meb.gov.tr/api/';

export const apiClient = axios.create({
  baseURL,
  timeout: 20000,
});

export function buildQuery(params) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return `?${searchParams.toString()}`;
}

export default apiClient;



